/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import KeyboardArrowLeftTwoTone from '@material-ui/icons/KeyboardArrowLeftTwoTone';
import Render from '@ion/dls/src/render/Render';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {isCurrentTheme} from '@ion/dls/src/theme/useThemeContext';
import {IconButton} from '../../components/buttons/IconButton';
import {SystemFindNearestIcon} from '../../icons/SystemFindNearestIcon';

// the current theme's geofence popup shows a geofence's details only - its
// geofences are edited from Admin Geofences, so it offers no Edit ...
type GeofenceDetailedActionContainerPopupProps = {
  hideFindNearbyContent?: () => void;
  showFindNearbyContent?: () => void;
  isTrackingV2?: boolean;
  showFindNearBy?: boolean;
  excludeFindNearby?: boolean;
};

const useStyles = makeStyles(() => {
  return {
    actionContainer : {
      display       : 'flex',
      flexDirection : 'row'
    },
    ctaActionContainer : {
      gap            : '4px',
      display        : 'flex',
      flexDirection  : 'row',
      justifyContent : 'space-evenly'
    }
  };
});

const GeofenceDetailedActionContainerPopup = ({
  hideFindNearbyContent,
  showFindNearbyContent,
  isTrackingV2 = false,
  showFindNearBy = false,
  excludeFindNearby = false
}: GeofenceDetailedActionContainerPopupProps) => {
  const classes = useStyles();

  return (
    <div className={classes.actionContainer}>
      <div className={classes.ctaActionContainer}>
        <Render.If condition={!excludeFindNearby && !isCurrentTheme()}>
          <IconButton icon={<SystemFindNearestIcon />}
            color={dlsColor('caBlue')}
            size={'small'}
            onClick={showFindNearbyContent} />
        </Render.If>
      </div>
      <Render.If condition={showFindNearBy && !isTrackingV2}>
        <IconButton icon={<KeyboardArrowLeftTwoTone />}
          color={dlsColor('caBlue')}
          padding={'4px'}
          onClick={hideFindNearbyContent} />
      </Render.If>
    </div>
  );
};

export default React.memo(GeofenceDetailedActionContainerPopup);
